const isRescheduleAppointmentResponse = (data)=>typeof data === 'object' && data !== null && 'appointment' in data && 'failures' in data
;
const fromRescheduleAppointmentQueryToAppointment = (data)=>{
    if (!data || !isRescheduleAppointmentResponse(data)) {
        return {
            appointment: undefined,
            failures: undefined
        };
    }
    let appointment;
    if (data.__typename === 'RescheduleAppointmentResponse' && data.appointment) {
        const { id , invitee , appointmentType , startTime , endTime , child , preferredChannelOfCommunication , customerComment , isReservation ,  } = data.appointment;
        var _lastName, _phone, _email;
        const inviteeForAppointment = invitee ? {
            firstName: invitee.firstName,
            lastName: (_lastName = invitee.lastName) !== null && _lastName !== void 0 ? _lastName : undefined,
            phone: (_phone = invitee.phone) !== null && _phone !== void 0 ? _phone : undefined,
            email: (_email = invitee.email) !== null && _email !== void 0 ? _email : undefined
        } : undefined;
        const typeForAppointment = appointmentType ? {
            id: appointmentType.id,
            name: appointmentType.name,
            description: appointmentType.description,
            ageGroup: appointmentType.ageGroup,
            duration: {
                amount: appointmentType.duration.amount,
                unit: appointmentType.duration.unit
            }
        } : undefined;
        var _lastName1;
        const childForAppointment = child ? {
            firstName: child.firstName,
            lastName: (_lastName1 = child.lastName) !== null && _lastName1 !== void 0 ? _lastName1 : undefined
        } : undefined;
        appointment = {
            id,
            isReservation: isReservation !== null && isReservation !== void 0 ? isReservation : undefined,
            endTime: new Date(endTime),
            startTime: new Date(startTime),
            invitee: inviteeForAppointment,
            appointmentType: typeForAppointment,
            child: childForAppointment,
            customerComment: customerComment !== null && customerComment !== void 0 ? customerComment : undefined,
            preferredChannelOfCommunication: preferredChannelOfCommunication !== null && preferredChannelOfCommunication !== void 0 ? preferredChannelOfCommunication : undefined
        };
    }
    const failures = data.__typename === 'RescheduleAppointmentResponse' ? data === null || data === void 0 ? void 0 : data.failures.map((failure)=>{
        return {
            type: failure.__typename,
            message: failure.message
        };
    }) : [];
    return {
        appointment,
        failures
    };
};

export { fromRescheduleAppointmentQueryToAppointment };
//# sourceMappingURL=fromRescheduleAppointmentQueryToAppointment.js.map
